/**
 * HITL-1756 — the most of one modifier an agent can ring on one item
 * ("coffee, 4 cream, 4 sugar") when the brand menu sets no limit: an unlimited
 * group (`max` -1) with no `max_per_option` (HITL-1762).
 */
export const MAX_MODIFIER_QUANTITY = 9;
